@if (variant() === SliderVariants.DEFAULT) {
  <b2c-default [items]="defaultItems()" />
} @else if (variant() === SliderVariants.FREE_MODE) {
  <b2c-free-mode
    #freeModeSlider
    [items]="freeModeItems()"
    [itemType]="itemType()!"
    (indexChange)="onIndexChange($event)"
  />
}
